import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function useMatomo() {
  const location = useLocation();

  useEffect(() => {
    // 确保 _paq 已定义（防止 index.html 加载失败时报错）
    if (!window._paq) return;

    // 1. 告诉 Matomo 当前 URL 变了
    window._paq.push(["setCustomUrl", window.location.href]);
    // 2. 告诉 Matomo 当前页面标题
    window._paq.push(["setDocumentTitle", document.title]);
    // 3. 发送 PageView
    window._paq.push(["trackPageView"]);
  }, [location]); // 只要路由变化，就执行一次
}
